import { authMethod } from '../config/appProperties';
import { getCookie1 } from './commonMethods';

export const getWithOutAuthJSONHeader = () => {
    let headers = ({
        "Content-Type": "application/json",
        "Application":"web"
    });
    return { headers: headers };
}

export const getAuthJSONHeader = () => {
    let headers =({
      "Content-Type": "application/json",
      Authorization: getToken(),
      "Application": "web"
    });
    return { headers: headers };
  }

export const getAuthFormHeader = () => {
    let headers = ({
        Authorization: getToken(),
        "Application":"web"
    });
    return { headers: headers };
}

export const getAuthJSONHeaderWithPassingToken = (bearerToken) => {
    let headers = ({
        "Content-Type": "application/json",
        "Authorization": "Bearer " + bearerToken,
        "Application":"web"
    });
    return { headers: headers };
}

export const getToken = () => {
    let token;
    if (authMethod?.toLowerCase() === "basic") {
        token = "Basic " + getCookie1("token");
    } else {
        token = "Bearer " + getCookie1("token");
    }
    return token;
}
export const getOnlyJSONContentHeader = () => {
    let headers = ({
        "Content-Type": "application/json",
    });
    return { headers: headers };
}
   export const getAuthJSONHeaderwithFBPixel=()=> {
    let headers = ({
      "Content-Type": "application/json",
      Authorization: getToken(),
      "Application":"web"
    });
    // let fbpValue = this.util.getFbpCookies();
    // let fbcValue = this.util.getFbcCookies();
    // let router_path = this.util.routerValue;
    // let fbEventId = this.createUniqueIdforFacebook();
    // let userAgent = this.util.getUserAgent();
    //  headers = headers.append("Application", "web");
    // headers = headers.append("userAgent", userAgent);
    // headers = headers.append("fbp_id", fbpValue);
    // headers = headers.append("fbc_id", fbcValue);
    // headers = headers.append("router_url", router_path);
    // headers = headers.append("fbeventId", fbEventId);
    return { headers: headers };
  }
